import styled from 'styled-components';

import { TextButton } from '@zillow/constellation';

export const StyledTextButton = styled(TextButton)`
  width: 100%;
  color: inherit;
  text-decoration: none;
`;
